import React from "react";
import Pagination from "react-bootstrap/Pagination";

function PaginationView({
  itemsPerPage,
  totalItems,
  paginateNext,
  paginatePrevious,
  currentPage,
  totalPages,
}) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const isLastPage = currentPage === pageNumbers.length;

  const handlePageClickNext = (e) => {
    e.preventDefault();
    if (!isLastPage) {
      paginateNext(currentPage + 1);
    }
  };

  const handlePageClickPrevious = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      paginatePrevious(currentPage - 1);
    }
  };

  console.log("itemsPerPage:", itemsPerPage);
  console.log("totalItems:", totalItems);
  // console.log("paginateNext:", paginateNext);
  // console.log("paginatePrevious:", paginatePrevious);
  console.log("currentPage:", currentPage);
  // console.log("Total Pages:", totalPages);

  return (
    <nav aria-label="Page navigation example" className="pagination-container">
      <Pagination className="pagination pagination-center">
        <Pagination.Item
          disabled={currentPage == 1}
          onClick={(e) => handlePageClickPrevious(e)}
          aria-label="Go to previous page"
        >
          &laquo;
        </Pagination.Item>

        {/* {pageNumbers.length > 1 &&
          pageNumbers.map((number) => (
            <Pagination.Item
              key={number}
              // onClick={(e) => handlePageClick(number, e)}
              active={number === currentPage}
            >
              {number}
            </Pagination.Item>
          ))} */}

        <Pagination.Item
          onClick={(e) => handlePageClickNext(e)}
          disabled={isLastPage}
          aria-label="Go to next page"
          // className={isLastPage ? "disabled-pagination-button" : ""}
        >
          &raquo;
        </Pagination.Item>
      </Pagination>
    </nav>
  );
}

export default PaginationView;
